import { defu } from 'defu'
const foldedMatcher = /* @__PURE__ */ (() => { const $0={redirect: "/auth/oidc/login"},$1={redirect: "/auth/oidc/logout"},$2={redirect: "/"},$3={}; return (m,p)=>{let r=[];if(p.charCodeAt(p.length-1)===47)p=p.slice(0,-1);if(p==="/auth/login"){r.push({data:$0});}else if(p==="/auth/logout"){r.push({data:$1});}else if(p.charCodeAt(p.length-1)===47){if(p==="/auth/login/"){r.push({data:$0});}else if(p==="/auth/logout/"){r.push({data:$1});}}let s=p.split("/");if(s.length>1&&s[s.length-1]===""){s.pop();p=p.slice(0,-1)}let l=s.length;if(l>1){if(s[1]==="dev"){r.push({data:$2,params:{"_":p.slice(5),}});}}r.push({data:$3,params:{"_":p.slice(1),}});return r.reverse();}})()
const decodeRoutePath = function decodeRoutePath(path) {
	if (!path.includes("%")) return path;
	const queryIndex = path.indexOf("?");
	const pathname = queryIndex === -1 ? path : path.slice(0, queryIndex);
	try {
		return queryIndex === -1 ? decodeURI(pathname) : decodeURI(pathname) + path.slice(queryIndex);
	} catch {
		return path;
	}
}
const normalizePath = (path, fold) => {
  if (typeof path !== 'string') { return path }
  const decoded = decodeRoutePath(path)
  return fold ? decoded.toLowerCase() : decoded
}
export default path => defu({}, ...foldedMatcher('', normalizePath(path, true)).map(r => r.data).reverse())